import { render, staticRenderFns } from "./ModalCommon.vue?vue&type=template&id=752b87cf&scoped=true&"
import script from "./ModalCommon.vue?vue&type=script&lang=js&"
export * from "./ModalCommon.vue?vue&type=script&lang=js&"
import style0 from "./ModalCommon.vue?vue&type=style&index=0&id=752b87cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b87cf",
  null
  
)

export default component.exports